
























































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Locales } from "@/i18n/locales";

@Component
export default class ExpansionPanelComponent extends Vue {
    @Prop() appInfo: any;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;
}
